export default function WarningBanner() {
  return (
    <div className="relative w-full overflow-hidden rounded-2xl border border-red-500/30 bg-linear-to-br from-[#2a1414] via-[#160c0c] to-[#0d0a0a] p-5 sm:p-6 lg:p-8">

      {/* Left Accent */}
      <div className="absolute left-0 top-0 h-full w-1 rounded-l-2xl bg-red-500" />

      <div className="flex flex-col lg:flex-row lg:items-start gap-6 lg:gap-12 pl-3">

        {/* Left Content */}
        <div className="w-full lg:w-2/5">

          <div className="mb-3 flex items-center gap-2">
            <span className="h-3.5 w-3.5 rounded-full border-2 border-red-500/40 bg-red-500" />

            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.18em] text-red-500">
              Wichtiger Hinweis
            </span>
          </div>

          <h2 className="text-xl sm:text-2xl lg:text-[1.75rem] font-bold leading-tight text-white">
            Das bisherige Staking-Programm wurde beendet
          </h2>

        </div>

        {/* Right Content */}
        <div className="w-full lg:w-3/5 text-sm sm:text-base lg:text-lg leading-7 text-zinc-300">

          Es sind keine neuen Einzahlungen möglich und es fallen keine weiteren Rewards an.

          <span className="font-semibold text-white">
            {" "}Deine Bestände inkl. erworbener Rewards bleiben vollständig gesichert
          </span>

          {" "}und können hier jederzeit abgezogen werden.

          {" "}An einem{" "}

          <span className="font-semibold text-white">
            neuen Staking-Programm
          </span>

          {" "}wird gearbeitet – Details folgen ausschliesslich über die offiziellen BlackChain-Kanäle.

        </div>

      </div>

    </div>
  );
}